export const TID = {
  // Auth
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  logout: "logout-button",

  // Nav
  navFacilities: "nav-facilities",
  navAudit: "nav-audit",
  navUsers: "nav-users",
  navImport: "nav-import",
  navReports: "nav-reports",
  navNotifications: "nav-notifications",

  // WhatsApp share
  whatsappShare: (id) => `whatsapp-share-${id}`,
  whatsappShareAlt: (id) => `whatsapp-share-alt-${id}`,

  // Report issue
  reportIssueTrigger: "report-issue-trigger",
  reportIssueMessage: "report-issue-message",
  reportIssueSeverity: "report-issue-severity",
  reportIssueSubmit: "report-issue-submit",

  // Bulk edit
  bulkSelectAll: "bulk-select-all",
  bulkSelectRow: (id) => `bulk-select-${id}`,
  bulkEditButton: "bulk-edit-button",
  bulkField: (name) => `bulk-field-${name}`,
  bulkSubmit: "bulk-submit-button",
  bulkCancel: "bulk-cancel-button",

  // Reports page
  reportRangeFrom: "report-range-from",
  reportRangeTo: "report-range-to",
  reportBucket: "report-bucket-select",
  reportDownloadCsv: "report-download-csv",

  // Facilities list
  searchInput: "facility-search-input",
  filterCategory: "filter-category-select",
  filterRegion: "filter-region-select",
  filterStatus: "filter-status-select",
  filterFlagged: "filter-flagged-toggle",
  clearFilters: "clear-filters-button",
  facilityTable: "facility-table",
  paginationPrev: "pagination-prev",
  paginationNext: "pagination-next",

  // Row / Drawer
  facilityRow: (id) => `facility-row-${id}`,
  openDrawer: (id) => `open-drawer-${id}`,
  drawer: "facility-drawer",
  drawerClose: "drawer-close-button",
  suspendTrigger: "suspend-trigger",
  reactivateTrigger: "reactivate-trigger",
  editTrigger: "edit-trigger",
  editSave: "edit-save-button",
  editCancel: "edit-cancel-button",
  editField: (field) => `edit-field-${field}`,

  // Suspend modal
  reasonInput: "reason-input",
  confirmSuspend: "confirm-suspend-button",
  confirmReactivate: "confirm-reactivate-button",
  cancelModal: "cancel-modal-button",

  // Users
  userRow: (id) => `user-row-${id}`,
  userExpandToggle: (id) => `user-expand-${id}`,
  userExpandedPanel: (id) => `user-panel-${id}`,
  approveUser: (id) => `approve-user-${id}`,
  revokeUser: (id) => `revoke-user-${id}`,
  deleteUser: (id) => `delete-user-${id}`,
  mergeUser: (id) => `merge-user-${id}`,
  unbindTgUser: (id) => `unbind-tg-${id}`,
  resetPasswordUser: (id) => `reset-pw-${id}`,
  roleSelect: (id) => `role-select-${id}`,
  editDisplayName: (id) => `edit-display-name-${id}`,
  editEmail: (id) => `edit-email-${id}`,
  editTelegramId: (id) => `edit-tg-id-${id}`,
  editTelegramUsername: (id) => `edit-tg-username-${id}`,
  saveUser: (id) => `save-user-${id}`,
  verifyBinding: (id) => `verify-binding-${id}`,
  verifyBindingResult: (id) => `verify-binding-result-${id}`,
  addUserButton: "add-user-button",
  addUserName: "add-user-name",
  addUserEmail: "add-user-email",
  addUserPassword: "add-user-password",
  addUserTelegramId: "add-user-telegram-id",
  addUserTelegramUsername: "add-user-telegram-username",
  addUserRole: "add-user-role",
  addUserSubmit: "add-user-submit",
  addUserCancel: "add-user-cancel",
  manageRolesBtn: "manage-roles-btn",
  usersSearch: "users-search-input",
  usersStatusFilter: (s) => `users-filter-${s}`,
  usersSurfaceFilter: (s) => `users-surface-${s}`,

  // Telegram permission editor
  tgPermsEditBtn: (id) => `tg-perms-edit-${id}`,
  tgPermsModal: "tg-perms-modal",
  tgPermsPreset: (name) => `tg-perms-preset-${name}`,
  tgPermsCheckbox: (key) => `tg-perms-checkbox-${key}`,
  tgPermsSave: "tg-perms-save",
  tgPermsCancel: "tg-perms-cancel",
  tgPermsCount: "tg-perms-count",

  // (removed: Clerk user directory — auth is now Emergent Google Auth)

  // Import
  importDropzone: "import-dropzone",
  importFileInput: "import-file-input",
  importSubmit: "import-submit-button",

  // Mass replacement (super-admin only)
  massReplaceTab: "mass-replace-tab",
  massReplaceFileInput: "mass-replace-file-input",
  massReplaceDropzone: "mass-replace-dropzone",
  massReplacePreview: "mass-replace-preview-button",
  massReplaceMode: (m) => `mass-replace-mode-${m}`,
  massReplaceDeleteMissing: "mass-replace-delete-missing",
  massReplaceConfirmInput: "mass-replace-confirm-input",
  massReplaceExecute: "mass-replace-execute-button",
  massReplaceCancel: "mass-replace-cancel-button",

  // AI bulk edit
  aiBulkEditButton: "ai-bulk-edit-button",
  aiBulkEditInstruction: "ai-bulk-edit-instruction",
  aiBulkEditStart: "ai-bulk-edit-start",
  aiBulkEditOption: (qid, key) => `ai-bulk-edit-option-${qid}-${key}`,
  aiBulkEditContinue: "ai-bulk-edit-continue",
  aiBulkEditApply: "ai-bulk-edit-apply",
  aiBulkEditCancel: "ai-bulk-edit-cancel",
  aiBulkEditRestart: "ai-bulk-edit-restart",
};

export const HOME = {
  emergentLink: "emergent-link",
};
